﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconSettings } from "@tabler/icons-react";
import { ServiciosConfiguracionDef } from "./ServiciosConfiguracionDef";

export const ServiciosConfiguracionHelpText = "* Aquí puede configurar los servicios.";
export const ServiciosConfiguracionIcon = IconSettings;
export class ServiciosConfiguracion extends Entity<ServiciosConfiguracionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ServiciosConfiguracionDef(), parentKeys);
        super.Form = import('./ServiciosConfiguracionForm').then((module) => module.ServiciosConfiguracionForm);
        this.Title = 'Configuración de Servicios';
        this.Icon = ServiciosConfiguracionIcon;
        this.HelpText = ServiciosConfiguracionHelpText;
    }
}